import React from 'react'

import 'web_common/css/LimnTech.css'
import { ProcessedPathInfo } from 'web_common/tsx/api/db/Models'
import BigTable from 'web_common/tsx/components/misc/BigTable'
import { util } from 'web_common/tsx/components/misc/Util'

interface ProposedPathUserTableProps {
    proposedPathList: Array<ProcessedPathInfo>,
}

const ProposedPathUserTable: React.FC<ProposedPathUserTableProps> = (props) => {
    let headers = [
        {
            title: "Path Name",
            field: "path_name",
            dateFilterable: false,
            width: 2000,
            minWidth: 300,
            sortable: true,
            searchable: true,
            customStringify: undefined,
            customSort: (a: string, b: string) => {
                return a.localeCompare(b)
            }
        },
        {
            title: "Path Description",
            field: "path_description",
            dateFilterable: false,
            width: 2000,
            minWidth: 300,
            sortable: true,
            searchable: true,
            customStringify: undefined,
            customSort: (a: string, b: string) => {
                return a.localeCompare(b)
            }
        },
        {
            title: "Date Created",
            field: "date_created",
            dateFilterable: true,
            width: 1000,
            minWidth: 300,
            sortable: true,
            searchable: true,
            customStringify: (d: Date) => {
                return util.formatDateString(d)
            },
            customSort: (a: Date, b: Date) => {
                return b.getTime() - a.getTime()
            },
        },
    ]

    let rows = props.proposedPathList.map(
        (obj, idx) =>
        {
            return {
                key: obj.id,
                path_name: obj.path_name,
                path_description: obj.path_description,
                date_created: obj.date_created,
            }
        }
    )

    return (
        <div>
            <div>
                <BigTable
                    title={"Proposed Path List"}
                    headers={headers}
                    rows={rows}
                    defaultSort={{
                        key: 'column-2',
                        order: 'desc'
                    }}
                    showDateFilter={true}
                    onVisibilityChange={(val)=>{}}
                />
            </div>
        </div>
    )
}

export default ProposedPathUserTable
